module.exports = __webpack_public_path__ + "img/IMG_0069.529bc9c5.jpg";